module.exports = __webpack_public_path__ + "img/movie.bb98fae7.png";